import { projectsSlice } from "./ProjectSlice";
const { actions } = projectsSlice;

export const setDynamicBreadcrumbs =
  (url, breadCrumbs) => (dispatch, getState) => {
    dispatch(actions.setDynamicBreadcrumbs({ [url]: breadCrumbs }));
  };
